export class AplicacionFrontModel {

    tipoApp: number;
    appDesc: string;
    appId: number;

    constructor() { }
}